import { FunctionComponent, SVGProps } from 'react';

export enum GlobalRouteNames {
  Page404 = '*',
  ChangeService = '/change-service',
  PaymentHistory = '/payment-history',
  ConnectionBrizTv = '/brizTV',
  ServicePayment = '/service-payment',
  ServiceSuspension = '/service-suspension',
  DailyServicePayment = '/daily-service-payment',
  ServiceManagement = '/service-management',
  AccountSettingPage = '/account-setting',
  SuccessPage = '/success',
  SuccessPublicPage = '/success-confirm',
  SuccessAddAccount = '/mc',
  OffersForYou = '/offers-for-you',
  SurveyPage = '/inner_page_for_survey',
  TopUpBalancePage = '/top-up-balance',
  RegistrationPage = '/registration',
  LoginPage = '/login',
  HomePage = '/',
  AccessDenied = '/access-denied',
  UnknownError = '/error-occurred',
  TimeOutError = '/error-timeout',
  ResetPasswordForm = '/reset-password',
  RecoveryByEmail = '/app/login/password-recovery-by-email',
  RecoveryByEmailWithoutApp = '/login/password-recovery-by-email',
  PasswordRecoveryAssistance = '/recovery-assistance',
  PasswordRecoveryByPhone = '/password-recovery-by-phone',
}

export enum AccountSettingRouteNames {
  AccountPage = '/',
  NotificationPage = '/notification',
  PasswordPage = '/password',
  AutoReplenishmentPage = '/auto-replenishment',
  DevicesPage = '/devices',
  DocumentsPage = '/documents',
  MultiAccountPage = '/multi-account',
}

export enum LoginRouteNames {
  AuthForm = '/',
  PasswordRecoveryByEmailFormWithoutApp = '/login/password-recovery-by-email',
  PasswordRecoveryByEmailForm = '/app/login/password-recovery-by-email',
  PasswordRecoveryByPhoneForm = '/password-recovery-by-phone',
  RequestCodeSmsForm = '/request-sms-code',
  EnterCodeSmsForm = '/enter-sms-code',
  ForgotPasswordForm = '/forgot-password',
  PasswordRecoveryAssistanceForm = '/recovery-assistance',
  TwoFactorAuth = '/two-factor-auth',
  Page404 = '*',
}

export enum SuccessRouteNames {
  PaymentSuccessfulPage = '/payment',
  ServiceActivationSuccessfulPage = '/activated',
  ServiceSuspendedSuccessfulPage = '/suspended',
  OttSuccessfulRequestPage = '/request-ott',
  BrizTvPromotion = '/ott',
  BrizTvConnected = '/briztv-connected',
  EmailConfirmed = '/email-confirmed',
  SurveySent = '/survey-sent',
  SurveySuccess = '/survey-success',
  MembershipConfirmed = '/membership-confirmed',
  AppPrefix = '/app',
  Page404 = '*',
}

export enum TopUpRouteNames {
  BankCard = '/bank-card',
  Page404 = '*',
}

export enum ButtonClassNames {
  PrimaryFulfilled = 'primary',
  PrimaryFulfilledSmall = 'primary-small',
  SecondaryOutlined = 'secondary',
  SecondaryOutlinedSmall = 'secondary small',
  SecondaryOutlinedBanner = 'secondary banner',
  YellowFulfilled = 'yellow',
  Icon = 'icon',
  IconFulfilled = 'icon fulfilled',
  IconGrayFulfilled = 'icon fulfilled gray',
  IconAccentFulfilled = 'icon fulfilled accent',
  IconPaginationFulfilled = 'icon fulfilled pagination',
  PromoFulfilled = 'promo-fulfilled',
  PromoFulfilledSmall = 'promo-fulfilled small',
}

export enum TableType {
  Basic = 'basic',
  Pagination = 'pagination',
}

export enum ModalVariants {
  GetHelp,
  AddNewCard,
  AddNewEmail,
  DeleteEmail,
  AddNewSmsPhone,
  EditSmsPhone,
  AddNewBackupPhone,
  AddNewIptvDevice,
  RestoreCallback,
  AnonymousFeedback,
  AcceptMembership,
  Callback,
  ConfirmNewSmsPhone,
  DeleteBackupPhone,
  DeleteSmsPhone,
  DeleteIptvDevice,
  DeleteCard,
  EditEmail,
  EditInternetLogin,
  EditMacAddress,
  EditInternetPassword,
  EditIptvDevice,
  EditBackupPhone,
  EditBrizTvEmail,
  EditBrizTvPhone,
  EditBrizTvPassword,
  LinkAccount,
  DeleteAccount,
  LeaveAccount,
  ConfirmationsLimit,
  PayMethods,
  ServiceSuspension,
  UnionCtvSuspension,
  Success,
  DeleteAutoReplenishmentEmail,
  ProductTourStart,
  ProductTourEnd,
  CheckRouter,
  InterviewRegistration,
  PromoShareThreeMonths,
  PaymentTypeMethods,
  SelectAccount,
  SubAccountSettings,
  TopUpTypeMethods,
  TopUpWarning,
  Confirmation,
  LogOut,
}

export enum LocalStorageItems {
  AccessToken = 'access_token',
  BrizTvEmail = 'brizTvEmail',
  BrizTvPhone = 'brizTvPhone',
  BrizTvPassword = 'brizTvPassword',
  Code = 'code',
  Phone = 'phone',
  Email = 'email',
  TopUpAmount = 'amount',
  ServiceName = 'serviceName',
  FromDate = 'fromDate',
  ControlledAccount = 'controlledAccount',
  RouterCapabilityChecked = 'routerCapabilityChecked',
  ToDate = 'toDate',
  TopUpBalance = 'topUpBalance',
  CallMeBack = 'call-me-back',
  ActiveServicesHidden = 'active-services-hidden',
  DeviceId = 'deviceId',
}

export enum WsEvents {
  PaymentComplete = 'payment.complete',
  BalanceChanged = 'user.balance.changed',
  PaymentError = 'payment.error',
}

export enum InputTextFormat {
  Currency = 'currency',
  Phone = 'phone',
  ScratchCardCode = 'scratchCardCode',
  MacAddress = 'mac-address',
  ContractNumberOrPhone = 'contractNumberOrPhone',
  ContractNumber = 'contractNumber',
  Iban = 'iban',
}

export enum AccountTypes {
  Union = 'union',
  Iptv = 'iptv',
  Ctv = 'ctv',
  Internet = 'internet',
}

export enum QueryParams {
  AccountId = 'accountId',
  AccountType = 'accountType',
  ServiceId = 'serviceId',
  BannerId = 'bannerId',
  Counts = 'counts',
  Lang = 'lang',
  ConnectFilms = 'connectFilms',
  ConnectStaticIp = 'connectStaticIp',
  IsChangeService = 'isChangeService',
}

export const InputRegexPattern = {
  Any: /^.*$/,
  InternetLogin: /^[a-z0-9_-]{1,16}$/g,
  MacAddress: /^([0-9A-Fa-f]{2}[-]){5}([0-9A-Fa-f]{2})$/g,
  AgreementNumber: /^[-.]+@([-]+)+[-]{2,4}$/g,
  Email: /^[\w.+-]+@([\w-]+\.)+[\w-]{2,}$/g,
  OnlyNumbers: /^[0-9]*$/i,
  Default: /^[^=]*$/i,
  LettersNumbersUnderscore: /[a-zA-Z0-9_]$/g,
  OneNumberOneLetter: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/g,
  Phone: /^\(?(0[0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{2})[-. ]?([0-9]{2})$/,
};

export interface BrizTvApp {
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  title: string;
  name: FunctionComponent<SVGProps<SVGSVGElement>>;
  description: string;
  link?: string;
  hoverText?: string;
}

export enum ServiceCardIconType {
  Internet = 'internet',
  Ctv = 'ctv',
  Iptv = 'iptv',
  InternetCtv = 'internetCtv',
  InternetIptv = 'internetIptv',
  InternetTvMax = 'internetTvMax',
}

export enum AccountStatus {
  Active = 1,
  WaitingForPayment = 0,
}

export enum LinksToIPTVMarathon {
  UA = 'https://www.briz.ua/news/smotrite-ukrainskie-telekanaly-besplatno',
  EN = 'https://www.briz.ua/en/news/smotrite-ukrainskie-telekanaly-besplatno',
  RU = 'https://www.briz.ua/ru/news/smotrite-ukrainskie-telekanaly-besplatno',
}

export enum CookieItems {
  INTERVIEW = 'interview',
  PRODUCT_TOUR = 'ProductTour',
}

export enum SharesAvailableList {
  SHARE_3_MONTHS = 35,
}

export enum CardSystem {
  VISA = 'Visa',
  MASTERCARD = 'MasterCard',
}

export enum UnknownCardSystem {
  NEW_CARD_DEFAULT = 'Unknown card',
}

export enum PaymentSystem {
  GOOGLE_PAY = 'GPay',
  APPLE_PAY = 'Apple Pay',
}

export type PaymentCardItems = CardSystem;
export type PaymentSystemItems = PaymentSystem;
export type PaymentDefaultItems = UnknownCardSystem;

export type PaymentTypeMethods = PaymentCardItems | PaymentSystemItems | PaymentDefaultItems;

export enum ScreenSize {
  Mobile = 360,
  Tablet = 768,
  Desktop = 1280,
}

export enum SessionStorageItems {
  BannerApp = 'bannerApp',
  SetFilms = 'setFilms',
  SetStaticIP = 'setStaticIP',
}

export enum ConnectServiceExItems {
  Films = 'films',
  StaticIP = 'staticIp',
}

export enum BannerApp {
  Opened = 'opened',
  Closed = 'closed',
}

export type BannerAppState = BannerApp;
